import type { FlowMetadata } from '../types/flow';

export type WorkflowAccessProjection = Pick<Partial<FlowMetadata>, 'access_pending' | 'read_only' | 'can_edit' | 'can_share' | 'can_delete' | 'can_duplicate' | 'can_archive' | 'can_restore' | 'can_organize' | 'is_owner' | 'capabilities'>;

export type WorkflowOperation = 'edit' | 'share' | 'delete' | 'duplicate' | 'archive' | 'restore' | 'organize';

/** Only current server projections establish edit authority; absent mode is unresolved. */
export function isWorkflowReadOnly(flow?: WorkflowAccessProjection | null): boolean {
  if (!flow || flow.access_pending === true || flow.read_only === true || flow.can_edit === false || flow.capabilities?.can_edit === false) return true;
  return !(flow.can_edit === true || flow.capabilities?.can_edit === true);
}

export function canPerformWorkflowOperation(flow: WorkflowAccessProjection | null | undefined, operation: WorkflowOperation): boolean {
  if (!flow) return false;
  const key = `can_${operation}` as const;
  const projected = flow.capabilities?.[key];
  const alias = flow[key];
  const grant = projected === false || alias === false ? false : projected ?? alias;
  // Personal organization is independent of source editing, when explicitly granted.
  if (operation === 'organize' && grant === true) return true;
  if (isWorkflowReadOnly(flow) || grant !== true) return false;
  if (operation === 'share') return grant === true;
  if (operation === 'delete') return flow.is_owner === true;
  return true;
}
